import React from 'react'

export default function ResultsAlerts({
  formStep, calculoReady, rows, invalidBaseRows, updaterWarnings,
  calidadIndicesBloqueante, mixedTagInconsistencyCount, rangoIndicesError,
  weakIndexStats, laborIntegrity, modoHerramienta, faltaHaberActual,
  rowsVista, indicesUnavailable,
}) {
  return (
    <>
      {formStep >= 5 && calculoReady && (rows.some((r) => r.requiresValidation) || invalidBaseRows.length > 0 || updaterWarnings.length > 0 || calidadIndicesBloqueante || mixedTagInconsistencyCount > 0) && (
        <div className="panel-profile-warn mt-3 rounded-xl p-3 text-profile-warn">
          <p className="text-xs font-semibold uppercase tracking-wide">Alertas a resolver antes del dictamen</p>
          <div className="mt-1 space-y-1 text-sm">
            {rows.some((r) => r.requiresValidation) && (
              <p>- Se detectaron montos con baja legibilidad en el PDF. Valida celdas marcadas.</p>
            )}
            {invalidBaseRows.length > 0 && (
              <p>- Faltan índices de actualización para el tramo {rangoIndicesError}. El dictamen queda bloqueado.</p>
            )}
            {updaterWarnings.length > 0 && (
              <p>- No se pudo hidratar una o más series oficiales. Se aplicó proyección técnica temporal.</p>
            )}
            {calidadIndicesBloqueante && (
              <p>- La calidad de indices en base 120 no alcanza umbral pericial (fallback fuerte: {weakIndexStats.weakPct}%).</p>
            )}
            {mixedTagInconsistencyCount > 0 && (
              <p>- Se detectaron {mixedTagInconsistencyCount} meses con renta de autónomos sin bandera estructural AUTONOMO. Revisar clasificación contributiva para evitar mezcla en fórmula mixta.</p>
            )}
          </div>
        </div>
      )}

      {formStep >= 5 && calculoReady && Number(laborIntegrity?.stats?.overlaps || 0) > 0 && (
        <div className="mt-3 rounded-xl border border-sky-300/35 bg-sky-500/10 p-3 text-sky-100">
          <p className="text-xs font-semibold uppercase tracking-wide">Simultaneidad detectada (permitida)</p>
          <p className="mt-1 text-sm">
            Se detectaron {laborIntegrity.stats.overlaps} periodos con multiempleador. Esto no bloquea el calculo ni el dictamen por si mismo;
            revisar dias y montos por CUIT para evitar sobrecomputo.
          </p>
        </div>
      )}

      {formStep >= 5 && calculoReady && modoHerramienta === 'avanzado' && faltaHaberActual && rowsVista.length > 0 && (
        <div className="panel-profile-danger mt-3 rounded-xl p-3 text-profile-danger">
              Debe ingresar el campo obligatorio "Haber mensual que percibe hoy" para calcular daño y diferencial.
        </div>
      )}
      {formStep >= 4 && indicesUnavailable && (
        <div className="mt-3 rounded-xl border border-rose-300/45 bg-rose-500/15 p-3 text-xs text-rose-100">
          Bloqueo técnico: no se detectó cobertura oficial suficiente de índices para el rango 2001-2021.
          Se deshabilita cálculo/dictamen para evitar resultados periciales inválidos por fallback sintético.
        </div>
      )}
    </>
  )
}
